<template>
  <div class="form-panel-item">
    <div class="name">
      <a-checkbox :value="formInfo.id" @change="onChange" :disabled="disabled">
                      <span class="name1" >
                        {{formInfo.abb }}
                      </span>
        <span class="name2">
                        {{formInfo.name}}
                      </span>
      </a-checkbox>

    </div>
    <div @click="formView">
      <a-row :gutter="20" class="info">
        <a-col :span="24" style="margin-top: 6px">
          <label class="label">
            用时：
          </label>
          <label  >
            {{formInfo.useTime}}min
          </label>
        </a-col>
        <a-col :span="24" >
          <label class="label">
            推荐：
          </label>
          <label >
            <a-rate :default-value="formInfo.score" allow-half :disabled="true"/>
          </label>
        </a-col>

      </a-row>
      <div class="info">
        <div class="label info1">
          场景：
        </div>
        <div class="info1 info1-description">
          <div class="one-row ">
            {{formInfo.useInfo || '-'}}
          </div>
        </div>
      </div>
    </div>
    <a-drawer
      title="表单"
      width="90%"
      :closable="false"
      @close="onViewClose"
      :visible="viewVisible"
    >
      <div style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 10px">
        {{current.name}}
      </div>
      <base-form-view :base-data="current"></base-form-view>
<!--      <a-tabs  v-model="activeKey"  >-->
<!--        <a-tab-pane  key="1" tab="预览" >-->
<!--          <base-form-view :base-data="current"></base-form-view>-->
<!--        </a-tab-pane>-->
<!--        <a-tab-pane  key="2" tab="编辑" >-->
<!--        </a-tab-pane>-->
<!--      </a-tabs>-->
    </a-drawer>
  </div>
</template>
<script>


import BaseFormView from '@comp/form/BaseFormView.vue'
import { getAction } from '@api/manage'

export default {
  name: 'FormCard',
  components: { BaseFormView },
  props:{
    disabled:{
      type:Boolean,
      default:false,
    },
    formInfo:{
      type:Object,
      default:()=>{
        return {  }
      }
    },

  },
  data(){
    return {
      viewVisible:false,
      current:{},
      activeKey:'1'
    }
  },
  computed:{

  },
  mounted(){
  },
  methods:{
    formView(){
      getAction('/tempconfig/tempConfigForm/getInfoByCode',{code:this.formInfo.code}).then(res=>{
        if(res.success){
          this.current = res.result
          this.viewVisible = true
        }
      })
    },
    onViewClose(){
      this.viewVisible = false
    },
    onChange(){
      this.$emit('change')
    }
  }
}
</script>
<style scoped lang="less">
.form-panel-item{
  background: rgba(255,255,255,0.15);
  // margin: 10px 10px 10px 0px;
  // width: calc(100% - 10px);
  padding: 10px;
  border-radius: 10px;
  .name{
    margin-bottom: 10px;
    .name1{
      color: white;
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
    }
    .name2{
      font-size: 14px;
      background-color: green;
      color: whitesmoke;
      padding: 4px;
      border-radius: 8px;
      min-width: 100px;
      text-align: center;
    }

  }
  .info{
    margin-top: 2px;
    overflow-x: auto;
    white-space: nowrap;
    .info1{
      float: left;
    }
    .info1-description{
      width: calc(100% - 60px);
    }
    .label{
      font-weight: 400;
      font-size: 12px;
      color: rgba(255,255,255,0.27);
    }
    label,.one-row{
      font-weight: 400;
      font-size: 14px;
      color: rgba(255,255,255,0.7);
    }
  }
}
</style>